/*
 * @Author: shannyHuang
 * @Date: 2022-08-02 17:11:04
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-02 20:17:57
 * @FilePath: /wemeet-web-activity/src/pages/create/mobile/IndustrySelect.tsx
 */
/** 行业选择 */
import React, { useState, useEffect, useCallback } from 'react';
import type { FC } from 'react';
import { Drawer, SelectList } from '@tencent/calendar-web-component-mobile';
import * as AccountServer from 'src/model/host-account';

import style from './index.module.scss';
import { Form } from '@tencent/tea-component';
import classnames from 'classnames';

interface IProps {
  label: string | React.ReactNode;
  name: string;
  selectVal?: Array<{ label: string; value: string }>;
  onChange?: Function;
  onClick?: () => void;
  isEdit?: boolean; // 区分创建和编辑
}
const IndustrySelect: FC<IProps> = ({ name, label, selectVal, onChange, onClick, isEdit }) => {
  const [active, setActive] = useState(false);
  const [industries, setIndustries] = useState<{ label: string; value: string }[]>([
    { label: '其他', value: '12' },
  ]);
  useEffect(() => {
    AccountServer.getIndustriesList().then((res) => {
      setIndustries(res.map((item) => ({ label: item.name, value: item.code })));
    });
  }, []);

  const show = useCallback(() => {
    if (isEdit) return;
    setActive(true);
    onClick?.();
  }, [setActive, onClick, isEdit]);
  const hide = useCallback(() => setActive(false), [setActive]);
  console.log('selectVal', selectVal);

  return (
    <Form.Item
      onClick={show}
      name={name}
      label={label}
      required
      className={classnames(isEdit && 'none-arrow')}
    >
      {isEdit ? (
        <div className={style.industriesName}>
          {selectVal?.map((item, index) => {
            if (index !== selectVal.length - 1) {
              return (
                <React.Fragment>
                  <p className={style.industry}>{item.label}</p>
                  <div className={style.line}></div>
                </React.Fragment>
              );
            }
            return <p className={style.industry}>{item.label}</p>;
          })}
        </div>
      ) : (
        <DrawerFormField
          visible={active}
          industries={industries}
          onClose={hide}
          value={selectVal}
          onChange={onChange}
        />
      )}
    </Form.Item>
  );
};

interface IDrawerFormFieldProps {
  value?: { label: string; value: string }[] | string[];
  visible: boolean;
  industries: { label: string; value: string }[];
  onChange?(...value: any): void;
  onClose(): void;
}
const DrawerFormField: FC<IDrawerFormFieldProps> = ({
  value,
  visible,
  industries,
  onChange,
  onClose,
}) => {
  // @ts-ignore
  const currentVal: IDrawerFormFieldProps['industries'] = (value || [])
    .map((v) => {
      if (typeof v === 'string') {
        return industries.find((item) => item.value === v);
      }
      return v;
    })
    .filter(Boolean);

  const mapTags = useCallback(
    (values?: { label: string; value: string }[]) => {
      if (values?.length) {
        return values.map((value) => value.label).join('、');
      }
      return <span className={style['item-placeholder']}>请选择</span>;
    },
    [industries],
  );

  const onSelect = useCallback(
    (ids: string[]) => {
      const industriesObj: Record<string, string> = industries.reduce(
        (prev, cur) => ({
          ...prev,
          [cur.value]: cur,
        }),
        {},
      );
      onChange?.(ids.map((id) => industriesObj[id]));
      onClose();
    },
    [onChange, industries, onClose],
  );

  return (
    <>
      <>{mapTags(currentVal)}</>
      <Drawer visible={visible} onClose={onClose} className={style['drawer-selector']}>
        <div className={style.title}>选择行业</div>
        <SelectList
          data={industries}
          maxSelect={1}
          value={currentVal?.map((v) => v.value)}
          onChange={onSelect}
        />
      </Drawer>
    </>
  );
};

export default IndustrySelect;
